import { Box, Typography } from 'nxg-ui-wrapper';
import { SystemStyleObject } from '@mui/system';

import { TextCommon } from '@Commons';
import { GLOBAL_MUI_SX } from '@Global';
import { StepperControl } from './components';
import CodePipelineProvider from './stores/provider';

const TYPO_H3_STYLE: SystemStyleObject = { textAlign: 'center', py: 2, fontWeight: 'bold' };
const TYPO_SUB_STYLE: SystemStyleObject = { textAlign: 'center', mb: 2, color: 'rgba(0, 0, 0, 0.6)' };

const CodePipelineSetting = (): React.ReactElement => {
  return (
    <CodePipelineProvider>
      <Box sx={GLOBAL_MUI_SX.flexVerticalGrow}>
        <Typography variant="h3" sx={TYPO_H3_STYLE}>
          {TextCommon.TEXT_CODEPIPELINE_GENERATION}
        </Typography>
        <Typography variant="subtitle1" sx={TYPO_SUB_STYLE}>
          {TextCommon.TEXT_CODEPIPELINE_GENERATION_DESCRIPTION}
        </Typography>
        <StepperControl />
      </Box>
    </CodePipelineProvider>
  );
};

export default CodePipelineSetting;
